import { createBrowserHistory } from 'history';
import { useLocation } from 'react-router-dom';
const history = createBrowserHistory();

// For searching query into url
export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function parseQuery(search) {
  let args = search.substring(1).split('&');
  let argsParsed = {};
  let i, arg, kvp, key, value;
  for (i = 0; i < args.length; i++) {
    arg = args[i];
    if (-1 === arg.indexOf('=')) {
      argsParsed[decodeURIComponent(arg).trim()] = true;
    } else {
      kvp = arg.split('=');
      key = decodeURIComponent(kvp[0]).trim();
      value = decodeURIComponent(kvp[1]).trim();
      argsParsed[key] = value;
    }
  }

  return argsParsed;
}

export function encodeQueryData(data) {
  return Object.keys(data)
    .map(key => {
      return (
        key && data[key] && [key, data[key]].map(encodeURIComponent).join('=')
      );
    })
    .filter(el => el != null && el != undefined && el != '')
    .join('&');
}

export default history;
